<template>
  <header class="charting-chart-header">
    <div class="charting-chart-header__identity">
      <strong>{{ ticker }}</strong>
      <span v-if="entryTypeLabel" class="charting-chart-header__entry">{{ entryTypeLabel }}</span>
      <span class="charting-chart-header__company" :title="companyName">{{ companyName }}</span>
      <slot name="actions" />
      <button type="button" class="charting-chart-header__toggle" :aria-expanded="String(expanded)"
        :aria-label="expanded ? 'Ocultar detalles del gráfico' : 'Mostrar detalles del gráfico'"
        @click="$emit('update:expanded', !expanded)">
        <span>Detalles</span><i :class="expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" aria-hidden="true"></i>
      </button>
    </div>
    <div v-if="expanded" class="charting-chart-header__details">
      <div class="charting-chart-header__values">
        <span class="charting-chart-header__date">{{ legend.dateLabel }}</span>
        <span v-for="item in legend.ohlcItems" :key="item.key" class="charting-chart-header__token">
          <b>{{ item.label }}</b> {{ item.value }}
        </span>
      </div>
      <div v-if="legend.overlayItems.length" class="charting-chart-header__values">
        <span v-for="item in legend.overlayItems" :key="item.key" class="charting-chart-header__token">
          <b :style="{ color: item.color }">{{ item.label }}</b> {{ item.value }}
        </span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'ChartingChartHeader',
  props: {
    ticker: { type: String, default: '' },
    companyName: { type: String, default: '' },
    entryTypeLabel: { type: String, default: '' },
    expanded: { type: Boolean, default: true },
    legend: { type: Object, default: () => ({ dateLabel: '', ohlcItems: [], overlayItems: [] }) }
  }
};
</script>

<style scoped>
.charting-chart-header { flex: 0 0 auto; min-width: 0; padding: 0.45rem 0.85rem; border-bottom: 1px solid var(--charting-b-border-color); background: var(--charting-b-panel-bg-strong); color: var(--p-text-color); }
.charting-chart-header__identity { display: flex; align-items: center; gap: 0.5rem; min-width: 0; font-size: 0.875rem; }
.charting-chart-header__company { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--text-color-secondary); font-size: 0.75rem; }
.charting-chart-header__entry { padding: 0.1rem 0.35rem; border: 1px solid var(--charting-b-border-color); border-radius: 999px; font-size: 0.65rem; }
.charting-chart-header__toggle { display: inline-flex; align-items: center; gap: 0.4rem; flex: 0 0 auto; margin-left: auto; min-height: 2rem; padding: 0.25rem 0.5rem; border: 0; border-radius: 0.5rem; background: transparent; color: var(--text-color-secondary); font: inherit; font-size: 0.75rem; cursor: pointer; }
.charting-chart-header__toggle:hover { background: var(--charting-b-hover-bg); }
.charting-chart-header__toggle:focus-visible { outline: 2px solid var(--brand-primary); outline-offset: 2px; }
.charting-chart-header__details { display: flex; flex-wrap: wrap; gap: 0.3rem 1rem; padding-bottom: 0.15rem; font-size: 0.75rem; font-variant-numeric: tabular-nums; }
.charting-chart-header__values { display: flex; flex-wrap: wrap; align-items: center; gap: 0.3rem 0.65rem; }
.charting-chart-header__token { white-space: nowrap; }
.charting-chart-header__token b, .charting-chart-header__date { color: var(--text-color-secondary); }
</style>
